const state = () => ({
  deleted: false,
  step: 1,
  feedbackReasons: [],
  feedbackDetails: ''
});

const getters = {
  deleted(state) {
    return state.deleted;
  },
  step(state) {
    return state.step;
  },
  feedbackReasons(state) {
    return state.feedbackReasons;
  },
  feedbackDetails(state) {
    return state.feedbackDetails;
  }
};

const mutations = {
  setDeleted(state, payload) {
    state.deleted = payload;
  },
  setStep(state, payload) {
    state.step = payload;
  },
  updateFeedbackReasons(state, payload) {
    if (Array.isArray(payload)) {
      state.feedbackReasons = payload;
    } else {
      state.feedbackReasons.push(payload);
    }
  },
  setFeedbackDetails(state, payload) {
    state.feedbackDetails = payload;
  },
  resetStore(state) {
    state.feedbackReasons = [];
    state.feedbackDetails = '';
  }
};

const actions = {
  setDeleted({ commit }, payload) {
    commit('setDeleted', payload);
  },
  setStep({ commit }, payload) {
    commit('setStep', payload);
    if (payload === 1) {
      commit('resetStore');
    }
  }
};

export const accountDelete = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
